export function createImpuesto() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Tasa: 0,
    Tipo: '',
    ClaveErp: '',
    EsActivo: true,
    Clave2: ''
  };
}
